import { render, staticRenderFns } from "./CreateJob.vue?vue&type=template&id=84a623b6&scoped=true"
import script from "./CreateJob.vue?vue&type=script&lang=js"
export * from "./CreateJob.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84a623b6",
  null
  
)

export default component.exports